export default __webpack_public_path__ + "static/media/zeitersparnis.a0ee3c4d.png";